import styled from "styled-components";
import {Container} from "react-bootstrap";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

export const PageSettingsContainer = styled.section`
  margin: 10px 20px 0 20px;
`

export const TabsBar = styled(Tabs)`
  width: 100%;
  margin-bottom: 10px;
`

export const LinkContainer = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-items: center;
`

export const LinkDiv = styled.div`
  margin-top: 10px;
  display: grid;
  gap: 10px;
  grid-template-columns: 20px 1fr;
  justify-items: left;
  align-items: center;
`
